export default __webpack_public_path__ + "static/media/mimi_thumb.416787a2.jpg";